import { type VariationGroupFieldsFragment } from '../../../__generated__/graphql-client-types';

/**
 * Maps variation groups to use the correct variant data based on the selected variant.
 *
 * @param variationGroups - Array of variation groups from the product family
 * @param selectedVariantName - The currently selected variant name
 * @returns Array of variation groups with options mapped to the selected variant
 */
export const mapVariationGroupsToSelectedVariant = (
	variationGroups: VariationGroupFieldsFragment[],
	selectedVariantName: string
): VariationGroupFieldsFragment[] => {
	return variationGroups.map((group) => ({
		...group,
		options: group.options.map((option) => {
			if (!option.variants?.length) {
				return option;
			}

			const matchingVariant = option.variants.find((variant) => variant.name.toLowerCase() === selectedVariantName.toLowerCase());

			if (!matchingVariant) {
				return option;
			}

			return {
				...option,
				image: matchingVariant.image,
				price: matchingVariant.price ? { current: matchingVariant.price } : option.price,
				url: matchingVariant.url ?? option.url
			};
		})
	}));
};
